import React from 'react';
import Tabs from '../components/Tabs';
import SearchPlatformExternalPlatformTab from './SearchPlatformExternalPlatformTab';
import SearchPlatformTab from './SearchPlatformTab';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';
import ExternalBrandLogo from '../components/ExternalBrandLogo';

const PLATFORMS_FRAGMENT = gql(`
  fragment SearchPlatformTabs_platforms on ExternalSearchPlatform {
    platform
  }
`);

const ICON_HEIGHT = 20;

interface SearchPlatformTabsProps {
  activePlatform?: string;
  encouragedPlatformSet: Set<string>;
  enabledPlatforms: DocumentType<typeof PLATFORMS_FRAGMENT>[];
  slabResultCount: string | null;
  searchQuery: string;
}

const SearchPlatformTabs = ({
  activePlatform,
  encouragedPlatformSet,
  enabledPlatforms,
  slabResultCount,
  searchQuery,
}: SearchPlatformTabsProps) => (
  <Tabs>
    <SearchPlatformTab
      icon={<ExternalBrandLogo brand="slab" height={ICON_HEIGHT} />}
      name="Slab"
      meta={slabResultCount}
    />
    {enabledPlatforms.map(({ platform }) => (
      <SearchPlatformExternalPlatformTab
        active={activePlatform === platform}
        encourageInstallation={encouragedPlatformSet.has(platform)}
        key={platform}
        platformKey={platform}
        searchQuery={searchQuery}
        iconHeight={ICON_HEIGHT}
      />
    ))}
  </Tabs>
);

export default SearchPlatformTabs;
